export default class StoreManager {
    static appdata = {
        isMobile: false,
    }
    static appState = {
        thisApp: null
    }
}
